import { z } from "zod/v4";

/**
 * How the current draft source came to be, shared by every codegen domain
 * (Agentic Logic rules, custom shipping providers):
 *
 *  - `chat` — the source was applied from the workspace AI chat and has not
 *    been hand-edited since.
 *  - `manual` — a person authored or last edited the source.
 *
 * Recorded on the draft at save time and copied onto the version at publish
 * time, so version history can attribute a version to the AI assistant.
 */
export const AgenticCodegenOriginList = ["chat", "manual"] as const;
export const AgenticCodegenOriginSchema = z.enum(AgenticCodegenOriginList);
export type AgenticCodegenOrigin = (typeof AgenticCodegenOriginList)[number];
